<template>
  <DialogBase
    title="Chuyển nhóm"
    :visible.sync="dialogVisible"
    size="sm"
    panel-icon="el-icon-sort"
    panel-icon-tone="warning"
    panel-title="Chuyển nhóm"
    panel-subtitle="Chuyển học sinh sang nhóm mới"
    :confirm-loading="loadingSwitchGroup"
    :confirm-disabled="selectNewGroup === ''"
    confirm-text="Xác nhận"
    confirm-type="primary"
    cancel-text="Hủy"
    cancel-type=""
    cancel-icon=""
    confirm-icon=""
    @before-close="handleClose"
    @cancel="handleClose"
    @confirm="handleSwitchGroup"
    @open="handleOpen"
  >
    <el-form
      ref="dataForm"
      label-position="top"
    >
      <el-form-item label="Nhóm cũ">
        <el-input disabled :value="nameOldGroup" />
      </el-form-item>

      <el-form-item label="Chọn nhóm mới" class="sk-u-mt-12">
        <el-select
          v-model="selectNewGroup"
          placeholder="Chọn nhóm mới"
          class="sk-u-w-full"
        >
          <el-option
            v-for="(item, index) in listNewGroup"
            :key="index"
            :label="item.nameGroup"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import { mapState } from "vuex";
import StudentGroupService from "@/services/Finance_Kids_V2/StudentGroupService";

export default {
  components: { DialogBase },
  computed: {
    ...mapState("studentGroupModule", ["dataSearch", "idKidList"]),
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingSwitchGroup: false,
      kidsGroupList: [],
      nameOldGroup: "",
      listNewGroup: [],
      selectNewGroup: "",
      listStudentParams: {
        idKidList: [],
        idGroupOld: "",
        idGroupNew: "",
      },
    };
  },
  methods: {
    handleOpen() {
      StudentGroupService.getListKidsGroup().then((res) => {
        res && res.data
          ? (this.kidsGroupList = res.data)
          : (this.kidsGroupList = []);
        for (let i = 0; i < this.kidsGroupList.length; i++) {
          if (this.kidsGroupList[i].id === this.dataSearch.idGroup) {
            this.nameOldGroup = this.kidsGroupList[i].nameGroup;
          }
        }
      });
      StudentGroupService.getListKidsGroup().then((response) => {
        this.listNewGroup = response.data;
      });
    },

    handleSwitchGroup() {
      this.loadingSwitchGroup = true;
      this.listStudentParams.idKidList = this.idKidList;
      this.listStudentParams.idGroupOld = this.dataSearch.idGroup;
      this.listStudentParams.idGroupNew = this.selectNewGroup;
      StudentGroupService.changeGroupForListStudents(
        this.listStudentParams
      ).then(() => {
        this.$message({
          type: "success",
          message: "Chuyển nhóm thành công.",
        });
        this.loadingSwitchGroup = false;
        this.handleClose();
      });
    },

    handleClose(done) {
      this.loadingSwitchGroup = false;
      this.selectNewGroup = "";
      this.$store.dispatch(
        "studentGroupModule/filter_students_group",
        this.dataSearch
      );
      this.$emit("dialog-close", false);
      if (typeof done === "function") done();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";
</style>